import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatLabel } from "../config";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

const LineChart = ({ lineData, color }) => {
    const labels = Object.keys(lineData ?? {})?.map(formatLabel);
    const data = Object.values(lineData ?? {});
    const chartData = {
        labels,
        datasets: [
            {
                data,
                borderColor: color,
                fill: true,
                tension: 0,
                pointRadius: 4,
            },
        ],
    };
    const formatNumber = (value) => {
        const number = Number(value);
        if (!Number.isFinite(number)) {
            return "0";
        }
        if (Number.isInteger(number)) {
            return number?.toLocaleString("en-IN");
        }
        return Number(number?.toFixed(2))?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 36,
                left: 12,
                right: 12,
                bottom: 8,
            },
        },
        plugins: {
            legend: { display: false },
            datalabels: {
                formatter: (value) => {
                    const number = Number(value);
                    return number === 0 ? "" : formatNumber(number);
                },
                anchor: "end",
                align: "top",
                offset: 8,
                color: "#1F1F1F",
                backgroundColor: "rgba(255, 255, 255, 0.94)",
                borderRadius: 4,
                padding: {
                    top: 2,
                    right: 6,
                    bottom: 2,
                    left: 6,
                },
                clamp: true,
                clip: false,
                font: {
                    weight: "600",
                },
            },
            tooltip: {
                callbacks: {
                    label: (text) => formatNumber(text?.raw),
                },
            },
        },
        scales: {
            x: {
                offset: true,
                grid: { display: false },
            },
            y: {
                grid: { color: "#ECECEC" },
                grace: "12%",
                ticks: {
                    callback: (value) => formatNumber(value),
                },
            },
        },
    };
    return <>
        <div style={{ height: 200 }}>
            <Line key={labels?.join("-") || "empty"} data={chartData} options={options} />
        </div>
    </>
};
export default LineChart